export default "__VITE_ASSET__DuGVWK6J__";